// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-sponsored{text-align:center}.search-sponsored img{max-width:248px;max-height:367px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
